
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/planetscale",
      function () {
        return require("private-next-pages/sources/planetscale.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/planetscale"])
      });
    }
  